import CheckinActionModal from "@/components/mirror/CheckinActionModal";
import { MIRROR_CHECKIN_CARDS_ENABLED } from "@/lib/featureFlags";
import { checkinOriginOperationId, checkinUuid, type CheckinActionPrefill } from "@/lib/checkinExecutor";
import { CHECKIN_EDITABLE_FIELDS, validCheckinDate } from "../../../../supabase/functions/_shared/checkinActionDomain";
import type { ModuleCaptureHandler } from "@/lib/capture/types";

/** The model drafts editable fields; the review supplies ownership and raw state. */
export const checkinActionCaptureHandler: ModuleCaptureHandler<CheckinActionPrefill> = {
  tool: "propose_checkin_action",
  isEnabled: () => MIRROR_CHECKIN_CARDS_ENABLED,
  getRawText: proposal => proposal.tool === "propose_checkin_action" ? JSON.stringify(proposal.args) : "",
  extract: async (_raw, proposal, ctx) => {
    if (proposal.tool !== "propose_checkin_action" ||
      !["save_today", "create_past", "update", "delete"].includes(proposal.args.action) ||
      !checkinUuid(ctx.ownerId) || !checkinUuid(ctx.sessionId)) return null;
    const args = structuredClone(proposal.args), owner = ctx.ownerId, session = ctx.sessionId;
    const assert = () => ctx.assertCurrent?.(); assert();
    if (["update", "delete"].includes(args.action) && !checkinUuid(args.checkin_id)) return null;
    if (args.action === "create_past" && !validCheckinDate(args.checkin_day)) return null;
    const operation_id = await checkinOriginOperationId(owner, session, proposal.action_id, "operation", assert);
    assert();
    const fields = args.fields && typeof args.fields === "object" && !Array.isArray(args.fields)
      ? Object.fromEntries(Object.entries(args.fields).filter(([key]) => CHECKIN_EDITABLE_FIELDS.includes(key as typeof CHECKIN_EDITABLE_FIELDS[number]))) : undefined;
    return {
      action: args.action, action_id: proposal.action_id, operation_id,
      expected_user_id: owner, expected_session_id: session,
      ...(checkinUuid(args.checkin_id) ? { checkin_id: args.checkin_id.toLowerCase() } : {}),
      ...(validCheckinDate(args.checkin_day) ? { checkin_day: args.checkin_day } : {}),
      ...(fields && args.action !== "delete" ? { fields } : {}),
    } as CheckinActionPrefill;
  },
  renderModal: props => <CheckinActionModal {...props} />,
};
